import React from "react";
//Layout
import MainLayout from "./components/layouts/MainLayout";

//Router config
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import PrivateRoute from "./config/routers/PrivateRoute";
import Authorization from "./services/Authorization";

//componentes
import Login from "./pages/Acceso/Login";

import Roles from "./pages/Acceso/Roles/Roles";
import RolesForm from "./pages/Acceso/Roles/RolesForm";
import Modulos from "./pages/Acceso/Modulos/Modulos";
import ModulosForm from "./pages/Acceso/Modulos/ModulosForm";
import RolesModulos from "./pages/Acceso/Roles/RolesModulos";
import Usuarios from "./pages/Acceso/Usuarios/Usuarios";

import UsuariosForm from "./pages/Acceso/Usuarios/UsuariosForm";
import ValidarAcceso from "./pages/Acceso/ValidarAcceso";
import SolicitarCorreoEnlace from "./pages/Acceso/SolicitarCorreoEnlace";
import Zonas from "./pages/Zonas/Zonas";
import ZonasForm from "./pages/Zonas/ZonasForm";
import ZonasDepartamento from "./pages/Zonas/ZonasDepartamento";
import Distritos from "./pages/Distritos/Distritos";
import DistritosForm from "./pages/Distritos/DistritosForm";
import Personas from "./pages/Personas/Personas";
import PersonasForm from "./pages/Personas/PersonasForm";
import MaestroInformes from "./pages/Maestro_Informes/MaestroInformes";
import MaestroInformesForm from "./pages/Maestro_Informes/MaestroInformesForm";
import NivelesPastorales from "./pages/NivelesPastorales/NivelesPastorales";
import NivelesPastoralesForm from "./pages/NivelesPastorales/NivelesPastoralesForm";
import Iglesias from "./pages/Iglesias/Iglesias";
import IglesiasForm from "./pages/Iglesias/IglesiasForm";
import IglesiasReportes from "./pages/Iglesias/IglesiasReportes";
import NivelesAcademicos from "./pages/NivelesAcademicos/NivelesAcademicos";
import NivelesAcademicoForm from "./pages/NivelesAcademicos/NivelesAcademicoForm";
import Pastores from "./pages/Pastores/Pastores";
import PastoresForm from "./pages/Pastores/PastoresForm";
import PeriodosMinisteriales from "./pages/PeriodosMinisteriales/PeriodosMinisteriales";
import PeriodosMinisterialesForm from "./pages/PeriodosMinisteriales/PeriodosMinisterialesForm";
import GestionesInformes from "./pages/Informes/GestionesInformes/GestionesInformes";
import GestionesInformesForm from "./pages/Informes/GestionesInformes/GestionesInformesForm";
import GestionesAsignacionInformes from "./pages/Informes/GestionesInformes/GestionesAsignacionInformes";
import PresentacionInformesIglesia from "./pages/Informes/PresentacionInformes/PresentacionInformesIglesia";
import PresentacionInformes from "./pages/Informes/PresentacionInformes/PresentacionInformes";
import InformeFinancieroMensual from "./pages/Informes/FormulariosInfomes/InformesIglesias/InformeFinancieroMensual/InformeFinancieroMensual";
import InformeMinisterialMensual from "./pages/Informes/FormulariosInfomes/InformesIglesias/InformeMinisterialMensual/InformeMinisterialMensual";
import InformeTesoreroMensual from "./pages/Informes/FormulariosInfomes/InformesIglesias/InformeTesoreroMensual/InformeTesoreroMensual";
import UsuariosIglesias from "./pages/Acceso/Usuarios/UsuariosIglesias";
import RecepcionInformesIglesias from "./pages/Informes/RecepcionInformes/RecepcionInformesIglesias/RecepcionInformesIglesias";
import RecepcionInformesIglesiasDetalle from "./pages/Informes/RecepcionInformes/RecepcionInformesIglesias/RecepcionInformesIglesiasDetalle";
import MembresiaIglesiasAsignadas from "./pages/Mebresia/MembresiaIglesiasAsignadas";
import MembresiaIglesiaDetalle from "./pages/Mebresia/MembresiaIglesiaDetalle";
import MebresiaIglesiaForm from "./pages/Mebresia/MebresiaIglesiaForm";
import MembresiaPerfil from "./pages/Mebresia/MembresiaPerfil";
import NombramientoPastores from "./pages/Nombramientos/Pastores/NombramientoPastores";
import NombramientoPastoresGestion from "./pages/Nombramientos/Pastores/NombramientoPastoresGestion";
import NombramientoPastorForm from "./pages/Nombramientos/Pastores/NombramientoPastorForm";
import CargosMinisteriales from "./pages/CargosMinisteriales/CargosMinisteriales";
import CargosMinisterialesForm from "./pages/CargosMinisteriales/CargosMinisterialesForm";
import UsuarioPerfil from "./pages/Acceso/Usuarios/UsuarioPerfil";
import TesorerosForm from "./pages/Tesoreros/TesorerosForm";
import HistoricoPresentacionInformesIglesias from "./pages/Informes/Historicos/InformesIglesias/HistoricosPresentacionInformes/HistoricoPresentacionInformesIglesias";
import HistoricoPresentacionInformesGestiones from "./pages/Informes/Historicos/InformesIglesias/HistoricosPresentacionInformes/HistoricoPresentacionInformesGestiones";
import HistoricoPresentacionInformesDetalle from "./pages/Informes/Historicos/InformesIglesias/HistoricosPresentacionInformes/HistoricoPresentacionInformesDetalle";
import HistoricoRecepcionInformesGestiones from "./pages/Informes/Historicos/InformesIglesias/HistoricoRecepcionInformes/HistoricoRecepcionInformesGestiones";
import HistoricoRecepcionInformesGestionesDetalle from "./pages/Informes/Historicos/InformesIglesias/HistoricoRecepcionInformes/HistoricoRecepcionInformesGestionesDetalle";
import HistoricoRecepcionInformesGestionesDetalleIglesias from "./pages/Informes/Historicos/InformesIglesias/HistoricoRecepcionInformes/HistoricoRecepcionInformesGestionesDetalleIglesias";
import Home from "./pages/Home/Home";
import SoporteTecnico from "./pages/SoporteTenico/SoporteTecnico";

function App() {
  return (
    <Router>
      <MainLayout>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route
            exact
            path="/validar_acceso/:codigo"
            component={ValidarAcceso}
          />
          <Route
            exact
            path="/restaurar_acceso"
            component={SolicitarCorreoEnlace}
          ></Route>

          <PrivateRoute exact path="/" component={Home} />

          {/**INICIO RUTAS ROLES */}
          <PrivateRoute
            exact
            path="/administracion/roles"
            component={Authorization(
              Roles,
              "289fd42f-b5d7-430f-a753-13ec027e4134"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/roles/new"
            component={Authorization(
              RolesForm,
              "289fd42f-b5d7-430f-a753-13ec027e4134"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/roles/update/:id"
            component={Authorization(
              RolesForm,
              "289fd42f-b5d7-430f-a753-13ec027e4134"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/roles/asignacion/:id"
            component={Authorization(
              RolesModulos,
              "289fd42f-b5d7-430f-a753-13ec027e4134"
            )}
          />
          {/**FIN RUTAS ROLES */}

          {/**INICIO RUTAS MODULOS */}
          <PrivateRoute
            exact
            path="/administracion/modulos"
            component={Authorization(
              Modulos,
              "f91cdcdd-6623-47d7-ae19-87b75e966ff6"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/modulos/new"
            component={Authorization(
              ModulosForm,
              "f91cdcdd-6623-47d7-ae19-87b75e966ff6"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/modulos/update/:id"
            component={Authorization(
              ModulosForm,
              "f91cdcdd-6623-47d7-ae19-87b75e966ff6"
            )}
          />
          {/**FIN RUTAS MODULOS */}
          {/**INICIO RUTAS USUARIOS */}
          <PrivateRoute
            exact
            path="/administracion/usuarios"
            component={Authorization(
              Usuarios,
              "0e265555-6b54-4f97-b520-c836c4f7b215"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/usuarios/new"
            component={Authorization(
              UsuariosForm,
              "0e265555-6b54-4f97-b520-c836c4f7b215"
            )}
          />

          <PrivateRoute
            exact
            path="/administracion/usuarios/update/:id"
            component={Authorization(
              UsuariosForm,
              "0e265555-6b54-4f97-b520-c836c4f7b215"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/usuarios/asignacion_iglesias/:id"
            component={Authorization(
              UsuariosIglesias,
              "0e265555-6b54-4f97-b520-c836c4f7b215"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/usuario/perfil"
            component={Authorization(
              UsuarioPerfil,
              "0e265555-6b54-4f97-b520-c836c4f7b215"
            )}
          />
          {/**FIN RUTAS USUARIOS */}

          {/**INICIO RUTAS ZONAS */}
          <PrivateRoute
            exact
            path="/organizacion/zonas"
            component={Authorization(
              Zonas,
              "c13a1b4d-612a-4f46-ba98-6b0bc5e10e47"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/zonas/new"
            component={Authorization(
              ZonasForm,
              "c13a1b4d-612a-4f46-ba98-6b0bc5e10e47"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/zonas/update/:id"
            component={Authorization(
              ZonasForm,
              "c13a1b4d-612a-4f46-ba98-6b0bc5e10e47"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/zonas/asignacion/:id"
            component={Authorization(
              ZonasDepartamento,
              "c13a1b4d-612a-4f46-ba98-6b0bc5e10e47"
            )}
          />
          {/**FIN RUTAS ZONAS */}

          {/**INICIO RUTAS Distritos */}
          <PrivateRoute
            exact
            path="/organizacion/distritos"
            component={Authorization(
              Distritos,
              "dcc3ec83-1367-4166-94e2-ba46c9c029a1"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/distritos/new"
            component={Authorization(
              DistritosForm,
              "dcc3ec83-1367-4166-94e2-ba46c9c029a1"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/distritos/update/:id"
            component={Authorization(
              DistritosForm,
              "dcc3ec83-1367-4166-94e2-ba46c9c029a1"
            )}
          />
          {/**FIN RUTAS Distritos */}
          {/**INICO RUTAS personas */}
          <PrivateRoute
            exact
            path="/recursos_humanos/personas"
            component={Authorization(
              Personas,
              "9c464bd0-6015-4927-a881-9b0005c645ed"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/personas/new"
            component={Authorization(
              PersonasForm,
              "9c464bd0-6015-4927-a881-9b0005c645ed"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/personas/update/:codigo"
            component={Authorization(
              PersonasForm,
              "9c464bd0-6015-4927-a881-9b0005c645ed"
            )}
          />
          {/**FIN RUTAS personas */}

          {/**INICIO RUTAS Maestro de informes */}
          <PrivateRoute
            exact
            path="/administracion/maestro_informes"
            component={Authorization(
              MaestroInformes,
              "6036af3b-234f-4c74-bdec-53a457f39d0a"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/maestro_informes/new"
            component={Authorization(
              MaestroInformesForm,
              "6036af3b-234f-4c74-bdec-53a457f39d0a"
            )}
          />
          <PrivateRoute
            exact
            path="/administracion/maestro_informes/update/:id"
            component={Authorization(
              MaestroInformesForm,
              "6036af3b-234f-4c74-bdec-53a457f39d0a"
            )}
          />
          {/**FIN RUTAS Maestro de informes */}

          {/**INICIO RUTAS NIVELES PASTORALES */}
          <PrivateRoute
            exact
            path="/recursos_humanos/niveles_pastorales"
            component={Authorization(
              NivelesPastorales,
              "1a087be0-a30e-4d26-af29-1846a20e2d1a"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/niveles_pastorales/new"
            component={Authorization(
              NivelesPastoralesForm,
              "1a087be0-a30e-4d26-af29-1846a20e2d1a"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/niveles_pastorales/update/:id"
            component={Authorization(
              NivelesPastoralesForm,
              "1a087be0-a30e-4d26-af29-1846a20e2d1a"
            )}
          />
          {/**FIN RUTAS NIVELES PASTORALES */}

          {/**INICIO RUTAS IGLESIAS */}
          <PrivateRoute
            exact
            path="/organizacion/iglesias"
            component={Authorization(
              Iglesias,
              "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/iglesias/new"
            component={Authorization(
              IglesiasForm,
              "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/iglesias/update/:id"
            component={Authorization(
              IglesiasForm,
              "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/iglesias/membresia/:iglesia"
            component={Authorization(
              MembresiaIglesiaDetalle,
              "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/iglesias/membresia/:iglesia/nuevo"
            component={Authorization(
              MebresiaIglesiaForm,
              "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
            )}
          />
          <PrivateRoute
            exact
            path="/organizacion/iglesias/asignacion_resportes/:id"
            component={Authorization(
              IglesiasReportes,
              "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
            )}
          />
          {/**FIN RUTAS IGLESIAS */}

          {/**INICIO RUTAS NIVELES Academicos */}
          <PrivateRoute
            exact
            path="/recursos_humanos/niveles_academicos"
            component={Authorization(
              NivelesAcademicos,
              "68ff3ca6-05c7-450b-9d6f-5e315ef76d6e"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/niveles_academicos/new"
            component={Authorization(
              NivelesAcademicoForm,
              "68ff3ca6-05c7-450b-9d6f-5e315ef76d6e"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/niveles_academicos/update/:id"
            component={Authorization(
              NivelesAcademicoForm,
              "68ff3ca6-05c7-450b-9d6f-5e315ef76d6e"
            )}
          />
          {/**FIN RUTAS NIVELES Academicos */}
          {/**INICIO RUTAS PASTORES */}
          <PrivateRoute
            exact
            path="/recursos_humanos/pastores"
            component={Authorization(
              Pastores,
              "753278e6-c194-4858-ab8e-5d3760cf5ea4"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/pastores/update/:codigo"
            component={Authorization(
              PastoresForm,
              "753278e6-c194-4858-ab8e-5d3760cf5ea4"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/pastores/new"
            component={Authorization(
              PastoresForm,
              "753278e6-c194-4858-ab8e-5d3760cf5ea4"
            )}
          />

          {/**FIN RUTAS PASTORES */}
          {/**INICIO RUTAS PERIODOS MINISTERIALES */}
          <PrivateRoute
            exact
            path="/periodos_ministeriales"
            component={Authorization(
              PeriodosMinisteriales,
              "18130aec-698b-4d2e-8f24-461eff84c4af"
            )}
          />
          <PrivateRoute
            exact
            path="/periodos_ministeriales/new"
            component={Authorization(
              PeriodosMinisterialesForm,
              "18130aec-698b-4d2e-8f24-461eff84c4af"
            )}
          />
          <PrivateRoute
            exact
            path="/periodos_ministeriales/update/:id"
            component={Authorization(
              PeriodosMinisterialesForm,
              "18130aec-698b-4d2e-8f24-461eff84c4af"
            )}
          />
          {/**FIN RUTAS NIVELES PERIODOS MINISTERIALES */}

          {/**INICIO RUTAS GESTIONES DE INFORMES */}
          <PrivateRoute
            exact
            path="/informes_mensuales/gestiones_entrega"
            component={Authorization(
              GestionesInformes,
              "069c8570-a351-4e5b-9228-448893c18e49"
            )}
          />
          <PrivateRoute
            exact
            path="/informes_mensuales/gestiones_entrega/new"
            component={Authorization(
              GestionesInformesForm,
              "069c8570-a351-4e5b-9228-448893c18e49"
            )}
          />
          <PrivateRoute
            exact
            path="/informes_mensuales/gestiones_entrega/asignacion_informes/:id"
            component={Authorization(
              GestionesAsignacionInformes,
              "069c8570-a351-4e5b-9228-448893c18e49"
            )}
          />
          <PrivateRoute
            exact
            path="/informes_mensuales/gestiones_entrega/asignados/:gestion_activa"
            component={Authorization(
              GestionesAsignacionInformes,
              "069c8570-a351-4e5b-9228-448893c18e49"
            )}
          />
          <PrivateRoute
            exact
            path="/informes_mensuales/gestiones_entrega/update/:id"
            component={Authorization(
              GestionesInformesForm,
              "069c8570-a351-4e5b-9228-448893c18e49"
            )}
          />
          {/**FIN RUTAS GESTIONES DE INFORMES */}

          {/**INCIO RUTAS PRESENTAR INFORMES */}
          <PrivateRoute
            exact
            path="/presentacion_informes/iglesia"
            component={Authorization(
              PresentacionInformes,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          <PrivateRoute
            exact
            path="/tesorero/create/:iglesia"
            component={Authorization(
              TesorerosForm,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          <PrivateRoute
            exact
            path="/tesorero/update/:iglesia/:id"
            component={Authorization(
              TesorerosForm,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          <PrivateRoute
            exact
            path="/presentacion_informes/iglesia/:id"
            component={Authorization(
              PresentacionInformesIglesia,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />

          <PrivateRoute
            exact
            path="/presentacion_informes/informe_financiero_mensual/gestion/:gestion/:iglesia/mes/:idMes"
            component={Authorization(
              InformeFinancieroMensual,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          <PrivateRoute
            exact
            path="/presentacion_informes/informe_financiero_mensual/gestion/:gestion/:iglesia/:ide"
            component={Authorization(
              InformeFinancieroMensual,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />

          <PrivateRoute
            exact
            path="/presentacion_informes/informe_ministerial_mensual/gestion/:gestion/:iglesia/mes/:idMes"
            component={Authorization(
              InformeMinisterialMensual,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          <PrivateRoute
            exact
            path="/presentacion_informes/informe_ministerial_mensual/gestion/:gestion/:iglesia/:ide"
            component={Authorization(
              InformeMinisterialMensual,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />

          <PrivateRoute
            exact
            path="/presentacion_informes/informe_tesorero_mensual/gestion/:gestion/:iglesia/mes/:idMes"
            component={Authorization(
              InformeTesoreroMensual,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          <PrivateRoute
            exact
            path="/presentacion_informes/informe_tesorero_mensual/gestion/:gestion/:iglesia/:ide"
            component={Authorization(
              InformeTesoreroMensual,
              "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
            )}
          />
          {/**FIN RUTAS PRESENTAR INFORMES */}

          {/**INICIO RUTAS  HISTORICO PRESENTAR INFORMES */}
          <PrivateRoute
            exact
            path="/historico/presentacion_informes/iglesia"
            component={Authorization(
              HistoricoPresentacionInformesIglesias,
              "0876a622-667a-4676-9dd8-3cc11520e8c7"
            )}
          />

          <PrivateRoute
            exact
            path="/historico/presentacion_informes/gestiones/:iglesia"
            component={Authorization(
              HistoricoPresentacionInformesGestiones,
              "0876a622-667a-4676-9dd8-3cc11520e8c7"
            )}
          />
          <PrivateRoute
            exact
            path="/historico/presentacion_informes/gestion/detalles/:gestion/:iglesia"
            component={Authorization(
              HistoricoPresentacionInformesDetalle,
              "0876a622-667a-4676-9dd8-3cc11520e8c7"
            )}
          />
          {/**FIN RUTAS  HISTORICO PRESENTAR INFORMES */}

          {/**INICIO RUTAS RECEPCION INFORMES */}
          <PrivateRoute
            exact
            path="/recepcion_informes/iglesia"
            component={Authorization(
              RecepcionInformesIglesias,
              "d56cf8b1-f637-446a-9b28-28bf846bdbac"
            )}
          />

          <PrivateRoute
            exact
            path="/recepcion_informes/iglesia/detalle_informe_recibido/:gestion/:id_informe"
            component={Authorization(
              RecepcionInformesIglesiasDetalle,
              "d56cf8b1-f637-446a-9b28-28bf846bdbac"
            )}
          />
          {/**FIN RUTAS RECEPCION INFORMES */}

          {/**INICIO RUTAS HSITORICO RECEPCION INFORMES */}
          <PrivateRoute
            exact
            path="/historico/recepcion_informes/iglesia"
            component={Authorization(
              HistoricoRecepcionInformesGestiones,
              "b1942651-be5b-4c3b-b6c8-d42f4df30f26"
            )}
          />
          <PrivateRoute
            exact
            path="/historico/recepcion_informes/iglesia/detalle/:gestion"
            component={Authorization(
              HistoricoRecepcionInformesGestionesDetalle,
              "b1942651-be5b-4c3b-b6c8-d42f4df30f26"
            )}
          />
          <PrivateRoute
            exact
            path="/historico/recepcion_informes/iglesia/detalle_informe_recibido/:gestion/:id_informe"
            component={Authorization(
              HistoricoRecepcionInformesGestionesDetalleIglesias,
              "b1942651-be5b-4c3b-b6c8-d42f4df30f26"
            )}
          />
          {/**FIN RUTAS HISTORICO RECEPCION INFORMES */}

          {/**INICIO RUTAS MEMBRESIA */}
          <PrivateRoute
            exact
            path="/membresia"
            component={Authorization(
              MembresiaIglesiasAsignadas,
              "4de7f531-714b-4a4c-a173-f6da077e37a5"
            )}
          />
          <PrivateRoute
            exact
            path="/membresia/perfil/:codigo"
            component={Authorization(
              MembresiaPerfil,
              "4de7f531-714b-4a4c-a173-f6da077e37a5"
            )}
          />

          <PrivateRoute
            exact
            path="/membresia/iglesia/:iglesia"
            component={Authorization(
              MembresiaIglesiaDetalle,
              "4de7f531-714b-4a4c-a173-f6da077e37a5"
            )}
          />

          <PrivateRoute
            exact
            path="/membresia/iglesia/:iglesia/nuevo"
            component={Authorization(
              MebresiaIglesiaForm,
              "4de7f531-714b-4a4c-a173-f6da077e37a5"
            )}
          />
          <PrivateRoute
            exact
            path="/membresia/iglesia/:iglesia/update/:codigo"
            component={Authorization(
              MebresiaIglesiaForm,
              "4de7f531-714b-4a4c-a173-f6da077e37a5"
            )}
          />
          {/**FIN RUTAS MEMBRESIA */}

          {/**INICIO RUTAS NOMBRAMIENTO PASTORES */}
          <PrivateRoute
            exact
            path="/nombramientos/pastorales"
            component={Authorization(
              NombramientoPastores,
              "6d04def8-20d0-4f6d-84ba-6320181879f8"
            )}
          />

          <PrivateRoute
            exact
            path="/nombramientos/pastorales/create"
            component={Authorization(
              NombramientoPastorForm,
              "6d04def8-20d0-4f6d-84ba-6320181879f8"
            )}
          />
          <PrivateRoute
            exact
            path="/nombramientos/pastorales/update/:id"
            component={Authorization(
              NombramientoPastorForm,
              "6d04def8-20d0-4f6d-84ba-6320181879f8"
            )}
          />
          <PrivateRoute
            exact
            path="/nombramientos/pastorales/gestion/:id"
            component={Authorization(
              NombramientoPastoresGestion,
              "6d04def8-20d0-4f6d-84ba-6320181879f8"
            )}
          />
          {/**FIN RUTAS  NOMBRAMIENTO PASTORES */}

          {/**INICIO RUTAS CARGOS MINISTERIALES */}
          <PrivateRoute
            exact
            path="/recursos_humanos/cargos_ministeriales"
            component={Authorization(
              CargosMinisteriales,
              "e2708ad4-a123-4c1b-bf3b-b599a4e778fe"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/cargos_ministeriales/new"
            component={Authorization(
              CargosMinisterialesForm,
              "e2708ad4-a123-4c1b-bf3b-b599a4e778fe"
            )}
          />
          <PrivateRoute
            exact
            path="/recursos_humanos/cargos_ministeriales/update/:id"
            component={Authorization(
              CargosMinisterialesForm,
              "e2708ad4-a123-4c1b-bf3b-b599a4e778fe"
            )}
          />
          {/**FIN RUTAS CARGOS MINISTERIALES */}

          <PrivateRoute
            exact
            path="/soporte-tecnico"
            component={Authorization(
              SoporteTecnico,
              "0b691254-6df0-416b-ab79-fd6e260a6c9a"
            )}
          />
          <Redirect to="/" />
        </Switch>
      </MainLayout>
    </Router>
  );
}

export default App;
